import {
  V1_URL
} from '../constants'

export const V1_ADJUSTMENTS = `${V1_URL}/adjustment`

export const V1_EXPORT_ADJUSTMENT = `${V1_ADJUSTMENTS}/export`

export const V1_IMPORT_ADJUSTMENTS = `${V1_ADJUSTMENTS}/import_adjustments`

export const V1_IMPORT_ADJUSTMENT_TEMPLATE = `${V1_ADJUSTMENTS}/import_adjustment_template`



// WEBPACK FOOTER //
// ./app/api/ingredientInventory/adjustment/constants.js